export default "__VITE_ASSET__CZRJzw8c__"